import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { Layout } from "../layout/Layout";
import { Home } from "../../pages/home/Home";
import { Error404 } from "../../pages/error-404/Error404";
import { Settings } from "../../pages/settings/Settings";
import { AddMail } from "../../pages/add-mail/AddMail";
import { PropertyDetails } from "../../pages/artifact-details/property/PropertyDetails";
import { ParcelDetails } from "../../pages/artifact-details/parcel/ParcelDetails";
import { Property } from "../../pages/property-page/Property";
import { AssignedToMe } from "../../pages/assigned-to-me/AssignedToMe";
import { ExportAppeals } from "../../components/export-appeals/ExportAppeals";
import { AddEditParcelPage } from "../../pages/add-edit-parcel/AddEditParcelPage";
import CreateEditPropertyPage from "../../pages/create-property-page/CreateEditPropertyPage";
import { UploadComps } from "../../pages/upload-comps/UploadComps";

export const propertyPaths = [
    "tax-bill-real",
    "value-notice-real",
    "hearing-notice-real",
    "check-real",
    "tax-bill-personal",
    "tax-return-personal",
    "value-notice-personal",
    "hearing-notice-personal",
    "check-personal",
    "parcel",
    "property",
    "unsorted-mails",
    "overdue-mails",
    "overdue-mails-to-me",
    "miscellaneous-real",
    "miscellaneous-personal",
];

export const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                index: true,
                element: <Home />,
            },
            {
                path: "/property-details",
                children: [
                    {
                        path: ":propertyId",
                        element: <PropertyDetails />,
                    },
                    {
                        path: ":propertyId/edit-property",
                        element: <CreateEditPropertyPage />,
                    },
                    {
                        path: ":parcelId/add-parcel",
                        loader: async params => {
                            return { ...params.params };
                        },
                        element: <AddEditParcelPage />,
                    },
                ],
            },
            {
                path: "/property-details/:propertyId/:year/export",
                element: <ExportAppeals />,
            },
            {
                path: "/parcel-details",
                children: [
                    {
                        index: true,
                        path: ":parcelId",
                        element: <ParcelDetails />,
                    },
                    {
                        path: ":parcelId/edit-parcel",
                        loader: async params => {
                            return { ...params.params };
                        },
                        element: <AddEditParcelPage />,
                    },
                ],
            },
            {
                path: "/settings",
                element: <Settings />,
            },
            {
                path: "/add-mail",
                element: <AddMail />,
                children: [
                    {
                        path: "*",
                        element: <AddMail />,
                    },
                ],
            },
            {
                path: "/upload-comps",
                element: <UploadComps />,
                children: [
                    {
                        path: "*",
                        element: <UploadComps />,
                    },
                ],
            },
            ...propertyPaths.map(path => {
                return {
                    path: path,
                    element: <Property />,
                    children: [
                        {
                            path: ":artifactId",
                        },
                    ],
                };
            }),
            {
                path: "create-property",
                element: <CreateEditPropertyPage />,
            },
            {
                path: "assigned-to-me/:documentType",
                element: <AssignedToMe />,
            },
            {
                path: "*",
                element: <Error404 />,
            },
        ],
    },
]);
